// extracted by mini-css-extract-plugin
export default {"card":"Card_card__loM4O","column":"Card_column__eBCG9","title":"Card_title__zJ52I"};